import Navbar from "../components/navbar";
import { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { NavLink } from "react-router-dom";
import businessloanmain from '../Assests/bank-loan.jpg'

function BusinessLoan() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setIsVisible(true), 200);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div>
            {/* Hero Section */}
            <div
                id="home"
                className="relative min-h-screen bg-gradient-to-br from-emerald-50 via-teal-100 to-green-50"
            >
                <Navbar />

                <div className="relative z-10 flex items-center min-h-[100vh] px-6 lg:px-12 pt-20">
                    <div className="max-w-7xl mx-auto w-full">
                        <div className="grid lg:grid-cols-2 gap-12 items-center">
                            {/* Left content */}
                            <div
                                className={`space-y-6 transition-all duration-1000 ${isVisible
                                    ? "opacity-100 translate-y-0"
                                    : "opacity-0 translate-y-10"
                                    }`}
                            >
                                <div className="space-y-4">
                                    <h1 className="text-3xl lg:text-5xl font-bold text-gray-900 leading-tight">
                                        Empower Your Business with{" "}
                                        <span className="bg-gradient-to-r from-emerald-400 via-teal-500 to-green-400 bg-clip-text text-transparent">
                                            Business Loans
                                        </span>{" "}
                                        in UAE
                                    </h1>

                                    <h2 className="text-2xl font-semibold text-gray-800">
                                        Expand, invest, and grow with tailored financing solutions
                                        designed for entrepreneurs and companies.
                                    </h2>

                                    <p className="text-base lg:text-lg text-gray-700 max-w-lg leading-relaxed">
                                        Access up to UAE 50 Million with flexible repayment terms,
                                        low interest rates, and quick approvals from leading banks.
                                    </p>
                                </div>

                                {/* CTA Button */}
                                <div className="pt-2">
                                    <NavLink to="/checkout">
                                        <button className="group inline-flex items-center gap-3 bg-gradient-to-r from-emerald-500 to-teal-600 text-white px-8 py-4 rounded-full text-base lg:text-lg font-semibold hover:from-emerald-400 hover:to-teal-500 transition-all duration-300 hover:scale-105 hover:shadow-2xl shadow-emerald-500/25">
                                            Apply for a Business Loan
                                            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
                                        </button>
                                    </NavLink>
                                </div>
                            </div>

                            {/* Right image */}
                            <div
                                className={`relative flex justify-center lg:justify-end transition-all duration-1000 delay-500 ${isVisible
                                    ? "opacity-100 translate-y-0"
                                    : "opacity-0 translate-y-10"
                                    }`}
                            >
                                <div className="relative">
                                    <div className="w-80 h-80 lg:w-96 lg:h-96 rounded-full overflow-hidden flex items-center justify-center shadow-xl border-4 border-white">
                                        <img
                                            src={businessloanmain}
                                            alt="Business Loan"
                                            className="object-cover w-full h-full"
                                        />
                                    </div>
                                    <div className="absolute inset-0 w-80 h-80 lg:w-96 lg:h-96 rounded-full bg-gradient-to-br from-emerald-300/40 via-teal-300/30 to-green-300/40 blur-xl scale-110 animate-pulse"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Business Loan Info Section */}
            <section className="py-16 px-6 lg:px-12 bg-white" id="info">
                <div className="max-w-6xl mx-auto space-y-12">
                    <h2 className="text-3xl font-bold text-gray-900 text-center">
                        Business Loans in the UAE
                    </h2>
                    <p className="text-lg text-gray-700 text-center max-w-3xl mx-auto">
                        Business loans in the UAE are designed to help entrepreneurs, SMEs, and
                        established companies access funds for expansion, working capital,
                        equipment purchase, or project financing. Leading banks in the UAE
                        offer tailored solutions with flexible repayment periods, competitive
                        profit rates, and quick approvals.
                    </p>

                    {/* Compare Table */}
                    <div className="overflow-x-auto">
                        <h3 className="text-2xl font-semibold mb-6 text-center">
                            Compare Business Loan Offers
                        </h3>
                        <table className="w-full border-collapse shadow-md rounded-lg overflow-hidden">
                            <thead>
                                <tr className="bg-emerald-600 text-white text-left">
                                    <th className="p-4">Bank</th>
                                    <th className="p-4">Max Loan Amount</th>
                                    <th className="p-4">Interest / Profit Rate</th>
                                    <th className="p-4">Repayment Period</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                <tr>
                                    <td className="p-4">Emirates NBD</td>
                                    <td className="p-4">Up to AED 3,000,000</td>
                                    <td className="p-4">Starting from 6.25% p.a.</td>
                                    <td className="p-4">Up to 48 months</td>
                                </tr>
                                <tr>
                                    <td className="p-4">ADCB</td>
                                    <td className="p-4">Up to AED 2,000,000</td>
                                    <td className="p-4">Starting from 6.99% p.a.</td>
                                    <td className="p-4">Up to 60 months</td>
                                </tr>
                                <tr>
                                    <td className="p-4">Mashreq Bank</td>
                                    <td className="p-4">Up to AED 1,500,000</td>
                                    <td className="p-4">Starting from 5.99% p.a.</td>
                                    <td className="p-4">Up to 48 months</td>
                                </tr>
                                <tr>
                                    <td className="p-4">RAKBANK</td>
                                    <td className="p-4">Up to AED 1,000,000</td>
                                    <td className="p-4">Starting from 7.5% p.a.</td>
                                    <td className="p-4">Up to 36 months</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>


            {/* FAQ Section */}
            <section className="py-16 px-6 lg:px-12 bg-gray-50" id="faq">
                <div className="max-w-5xl mx-auto space-y-10">
                    <h2 className="text-3xl font-bold text-gray-900 text-center">
                        Business Loan FAQs
                    </h2>
                    <div className="space-y-6">
                        <div>
                            <h3 className="font-semibold text-lg">
                                What can I use a business loan for?
                            </h3>
                            <p className="text-gray-700">
                                Business loans can be used for working capital, expansion,
                                purchasing inventory, or investing in new projects.
                            </p>
                        </div>
                        <div>
                            <h3 className="font-semibold text-lg">
                                Do I need collateral for a business loan?
                            </h3>
                            <p className="text-gray-700">
                                Some banks require collateral while others offer unsecured
                                business loans depending on your business profile.
                            </p>
                        </div>
                        <div>
                            <h3 className="font-semibold text-lg">
                                How long does loan approval take?
                            </h3>
                            <p className="text-gray-700">
                                Typically, 5–10 working days depending on documentation and
                                eligibility.
                            </p>
                        </div>
                        <div>
                            <h3 className="font-semibold text-lg">
                                What documents are required?
                            </h3>
                            <p className="text-gray-700">
                                CNIC, business registration certificate, tax returns, bank
                                statements, and financial reports are usually required.
                            </p>
                        </div>
                        <div>
                            <h3 className="font-semibold text-lg">
                                Can startups apply for a business loan?
                            </h3>
                            <p className="text-gray-700">
                                Some banks offer financing for startups, but generally they
                                require at least 2 years of business operations.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Representative Illustration Section */}
            <section className="py-16 px-6 lg:px-12 bg-gray-50">
                <div className="max-w-5xl mx-auto text-center">
                    <h2 className="text-3xl font-bold text-emerald-700 mb-6">
                        Representative Illustration
                    </h2>

                    <div className="overflow-x-auto">
                        <table className="w-full border border-gray-200 rounded-lg shadow-md bg-white">
                            <tbody>
                                <tr className="border-b">
                                    <td className="p-4 font-semibold text-gray-700">
                                        Repayment Period
                                    </td>
                                    <td className="p-4 text-gray-600">
                                        12 to 84 months (depending on bank & loan type)
                                    </td>
                                </tr>
                                <tr className="border-b">
                                    <td className="p-4 font-semibold text-gray-700">
                                        Maximum APR
                                    </td>
                                    <td className="p-4 text-gray-600">
                                        Up to 20% per annum
                                    </td>
                                </tr>
                                <tr className="border-b">
                                    <td className="p-4 font-semibold text-gray-700">
                                        Processing Fee
                                    </td>
                                    <td className="p-4 text-gray-600">
                                        1–2% of loan amount
                                    </td>
                                </tr>
                                <tr>
                                    <td className="p-4 font-semibold text-gray-700">
                                        Representative Example
                                    </td>
                                    <td className="p-4 text-gray-600">
                                        PKR 5,000,000 for 5 years at 14% p.a. + 1.5% fee ≈ Total
                                        Cost PKR 7,050,000, Monthly ≈ PKR 117,500
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <p className="mt-6 text-sm text-gray-500 leading-relaxed">
                        This is a representative example for illustration only. Actual terms
                        and costs may vary depending on your bank and loan type.
                    </p>
                </div>
            </section>

            {/* Footer */}
            <footer className="bg-gradient-to-br from-emerald-50 via-teal-100 to-green-50 py-10 px-6 lg:px-12">
                <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* Logo + About */}
                    <div>
                        <h3 className="text-xl font-bold bg-gradient-to-r from-emerald-600 to-teal-500 bg-clip-text text-transparent">AE Finance</h3>
                        <p className="mt-3 text-sm text-gray-400 leading-relaxed">
                            Your trusted partner for finding the best loan and credit card deals in
                            the UAE. We connect you with top banks and financial institutions to
                            make borrowing simple and transparent.
                        </p>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h4 className="text-lg font-semibold bg-gradient-to-r from-emerald-600 to-teal-500 bg-clip-text text-transparent">Contact Us</h4>
                        <p className="text-sm text-gray-400">Email: aft4417@gmail.com</p>
                        <p className="text-sm text-gray-400">Phone: +971558720718</p>
                        <p className="text-sm text-gray-400 mt-2">
                            Jebel Ali Free Zone · Street: Po Box 27074. City: Abu Dhabi
                        </p>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="mt-8 border-t border-gray-700 pt-4 text-center text-sm text-gray-500">
                    © {new Date().getFullYear()} AE Finance. All Rights Reserved.
                </div>
            </footer>
        </div>
    );
}

export default BusinessLoan;
